/* eslint-disable react/jsx-max-depth */
import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import {
  ExpandMore,
  CheckCircleOutline,
  HighlightOff,
  MoreVert,
  Replay,
  PersonOutlined,
} from '@material-ui/icons'
import {
  Button,
  Collapse,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  Paper,
} from '@material-ui/core'
import { FormattedMessage, injectIntl } from 'react-intl'
import isEmpty from 'lodash/isEmpty'
import parse from 'html-react-parser'
import isEqual from 'lodash/isEqual'
import cn from 'classnames'
import StatusIcon from 'routes/App/Apps/DailyLogbookEvents/Questionnaire/StatusIcon'
import SidePopover from 'components/common/Popover/SidePopover'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import FuncHelper from 'helpers/functions'
import { embedableYoutubeVideo } from 'helpers/youtubeVideo'
import { TABLET_BREAKPOINT, LAPTOP_BREAKPOINT } from 'helpers/responsive'
import ConfirmDialog from 'components/common/Popup/ConfirmDialog'
import withPromise from 'helpers/withPromise'
import {
  STATUS_COMPLETED,
  STATUS_IN_PROGRESS,
  STATUS_NOT_STARTED,
  LOCUS_GROUP_FIELD,
  LOCUS_FIELD,
  REOPEN_ITEM,
  COMPLETE_ITEM,
  DUPLICATE_ITEM,
  DELETE_ITEM,
  REASSIGN_ITEM,
  REASSIGN_SERIES,
  TYPE_INPUT_TEXT,
  TYPE_INPUT_NUMBER,
  DUPLICATE_ITEM_WITH_DATA,
  TYPE_SELECT,
  TYPE_INPUT_DATE,
  TYPE_INPUT_DATE_TIME,
  TYPE_INPUT_BOOLEAN,
  TYPE_INPUT_FILE,
} from 'helpers/jobs'
import {
  saveJobTaskInput,
  updateJobTaskInput,
  saveJobMultiTaskInputs,
  updateJobMultiTaskInputs,
  createEvtJobTask,
  createEvtJobMultiTask,
  updateJobTask,
  deleteTask,
  resetInvalidDates,
  duplicateInputGroup,
  deleteDuplicatedInputGroup,
  evaluateCalculationFields,
  fetchJobTaskList,
  handleDependentLookupInputs,
  setPreviewInputs,
  clearEvtInputsResults,
  updateTaskPreviewInputs,
} from 'reducers/myJobs/reducer'
import { ReactComponent as UsersGroupIcon } from 'assets/img/users-group.svg'
import { ReactComponent as ActiveUsersGroupIcon } from 'assets/img/active-users-group.svg'
import { ReactComponent as DuplicateIcon } from 'assets/img/ic_duplicate.svg'
import { ReactComponent as DateIcon } from 'assets/img/date-icon.svg'
import { ReactComponent as RepeatIcon } from 'assets/img/repeat-icon.svg'
import { ReactComponent as PlaceIcon } from 'assets/img/place-icon.svg'
import { ReactComponent as ImageIcon } from 'assets/img/image-icon.svg'
import { ReactComponent as VideoIcon } from 'assets/img/video-icon.svg'
import { ReactComponent as CloseIcon } from 'assets/img/close-icon.svg'
import { getFormattedDate, getTimeFormat, getDateFormat } from 'helpers/dates'
import ImageModal from 'components/common/Modals/ImageModal'
import TextEditor from 'components/common/TextEditor'
import Loading from 'components/Loading'
import { showNotice } from 'reducers/notice'
import NoticeHelper from 'helpers/notice'
import {
  ACTION_DUPLICATE,
  ACTION_DUPLICATE_WITH_DATA,
  DUPLICATE_INSERT_PARAMETER_AFTER,
} from 'constants/index'
import {
  PREVIEW_INTERNAL_PARTS_COUNT,
  PREVIEW_WITH_DYNAMIC_INTERNAL_PARTS_COUNT,
} from 'constants/preview'
import { isParentLookupInputsFilledIn } from 'helpers/myJobs'
// import FadeInImage from 'components/common/FadeInImage'
import ReactImageAppear from 'react-image-appear'
import PreviewInputValues from '../Common/PreviewInputValues'
import { Hint } from '../styles'
import CollapsibleUnits from './CollapsibleUnits'
import JobTaskUnits from './JobTaskUnits'
import ReassignDialog from './ReassignDialog'
import JobField from '../JobFields'
import JobTaskPolicies from './JobTaskPolicies'
import JobTaskBulkRun from './JobTaskBulkRun'
import InputGroupItem from './InputGroupItem'
import messages from '../translate'
import {
  canRenderConditionalInputOrGroup,
  getConditionalItemsIds,
  filterConditionalItems,
  applyPopulatedEvtInputsToEvtInputs,
  clearPopulatedEvtInputsFromEvtInputs,
  mergeConditionalItems,
  isEvtInputResultEmpty,
} from '../Common/utils'
import { CONDITIONAL_ITEM_TYPE } from '../Common/Common.types'

class JobTask extends Component {
  constructor(props) {
    super(props)

    this.state = {
      savingEvtJobEntry: false,
      locus: null,
      locusGroup: null,
      isOpenReassignDialog: false,
      currentTask: {},
      isDialogOpen: false,
      popupTitle: '',
      popupMessage: '',
      popupAction: FuncHelper.emptyFunc,
      anchor: null,
      isExtraMenuOpen: false,
      activeUnits: {},
      activeUnitId: null,
      showImageBlock: false,
      isModalOpen: false,
      showVideoBlock: false,
      isVideoIframeLoading: false,
      prevTaskId: null,
      valueOutOfRange: false,
      isDisabledInput: false,
      isFocusedInput: false,
      reassignType: null,
      multiUnitTaskIds: [],
      notExistingUnitTaskIds: [],
      multiChoiceMode: false,
      isDebouncing: false,
      errors: {},
    }

    this.inputGroupIndex = 1
    this.taskRef = createRef()
  }

  // eslint-disable-next-line max-statements
  componentDidMount() {
    const {
      id,
      activeTask,
      tasksData,
      location,
      setTasksOffsetPosition,
      scrollToTaskPosition,
      needs_locus,
      needs_locus_group,
      evt_tasks,
      isSingleTask,
      setInvalidSingleInput,
      optional,
    } = this.props
    const taskRef = this.taskRef && this.taskRef.current
    const taskDataPosition =
      !isEmpty(tasksData) && tasksData.currentTaskPosition
    const windowWidthLimit = ifWindowWidthLessThan(TABLET_BREAKPOINT)
    const hasEvtInputs = evt_tasks.find(({ evt_inputs }) => evt_inputs.length)
    const taskScrollPosition = windowWidthLimit
      ? taskRef.offsetTop
      : taskRef.getBoundingClientRect().top

    if (!needs_locus && !needs_locus_group && !isEmpty(evt_tasks)) {
      this.setCurrentTask(evt_tasks[0])
    }

    if (location.search) {
      const queryParams = new URLSearchParams(location.search)
      const taskId = +queryParams.get('task_id')
      const locusName = queryParams.get('locus')
      const locusGroupName = queryParams.get('locus_group')
      let unit

      if (id === taskId) {
        const locusGroup = this.findLocusGroupByName(locusGroupName)
        const locus = this.findLocusByName(locusName)

        if (locusName && locusGroupName) {
          unit = locusGroup && locusGroup.id
        } else {
          if (locusGroupName) {
            unit = locusGroup && locusGroup.id
          }

          if (locusName) {
            unit = locus && locus.id
          }
        }

        if (unit) {
          this.handleUnitsChange(unit)
          this.setCurrentTaskUnits(LOCUS_FIELD, unit, true)
          scrollToTaskPosition(taskScrollPosition)
        }
      }
    }

    if (typeof taskScrollPosition === 'number') {
      setTasksOffsetPosition({ [id]: taskScrollPosition })
    }

    if (windowWidthLimit && taskDataPosition && activeTask) {
      scrollToTaskPosition(taskDataPosition)
    }

    if (isSingleTask) {
      if (!(optional && !hasEvtInputs) || !optional) {
        setInvalidSingleInput(!this.isRequiredInputsFilled())
      } else {
        setInvalidSingleInput(false)
      }

      this.onJobTaskClickHandler(id)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      locus,
      locusGroup,
      prevTaskId,
      currentTask,
      isFocusedInput,
      activeUnitId,
    } = this.state
    const { isFocusedInput: prevIsFocusedInput } = prevState
    const {
      locusList,
      locusGroupList,
      tasksData,
      id,
      activeTask,
      evt_tasks,
      needs_locus,
      needs_locus_group,
      isSingleTask,
      setIsFocused,
      isNextTaskActive,
    } = this.props
    const {
      locusList: prevLocusList,
      locusGroupList: prevLocusGroupList,
    } = prevProps
    const locusId = this.hasOnlySingleUnit(locusList) && locusList[0].id
    const groupId =
      this.hasOnlySingleUnit(locusGroupList) && locusGroupList[0].id
    const prevLocusId =
      this.hasOnlySingleUnit(prevLocusList) && prevLocusList[0].id
    const prevGroupId =
      this.hasOnlySingleUnit(prevLocusGroupList) && prevLocusGroupList[0].id
    const isTasksDataExist = Object.keys(tasksData).length > 1
    const isTaskOpen =
      isTasksDataExist && tasksData[activeTask] === 'open' && activeTask === id
    const withoutLocus = !needs_locus && !needs_locus_group

    if (isSingleTask && isFocusedInput !== prevIsFocusedInput) {
      setIsFocused(isFocusedInput)
    }

    if (locusId && !locus && locusId !== prevLocusId) {
      this.setCurrentTaskUnits(LOCUS_FIELD, locusId)
    }

    if (groupId && !locusGroup && groupId !== prevGroupId) {
      this.setCurrentTaskUnits(LOCUS_GROUP_FIELD, groupId)
    }

    if (locusGroup !== prevState.locusGroup) {
      const findSingeLocus = locusGroupList.find(group => {
        const { locuses, id } = group

        return locuses && locuses.length === 1 && id === locusGroup
      })

      if (findSingeLocus && needs_locus && needs_locus_group) {
        const {
          locuses: [{ id }],
        } = findSingeLocus
        this.setCurrentTaskUnits(LOCUS_FIELD, id)
      }
    }

    const { evt_inputs } =
      evt_tasks.find(task => currentTask && task.id === currentTask.id) || {}

    if (prevTaskId !== activeTask && !activeUnitId && isNextTaskActive) {
      this.onJobTaskClickHandler(activeTask)
    } else if (
      (!this.checkData(evt_tasks) &&
        isTaskOpen &&
        withoutLocus &&
        prevTaskId !== activeTask) ||
      (currentTask.evt_inputs &&
        evt_inputs &&
        evt_inputs.length > currentTask.evt_inputs.length)
    ) {
      this.getSuitableTask()
    }
  }

  shouldComponentUpdate(nextProps) {
    const { evt_tasks, needs_locus, needs_locus_group } = this.props
    const { currentTask } = this.state
    const next_evt_tasks = nextProps.evt_tasks
    const checkLocuses = !needs_locus_group && !needs_locus

    if (this.checkData(next_evt_tasks) && !isEqual(evt_tasks, next_evt_tasks)) {
      const findTask = next_evt_tasks.find(
        task => currentTask && task.id === currentTask.id,
      )

      if (checkLocuses && findTask) {
        this.setCurrentTask(findTask)
      } else {
        this.getSuitableTask(next_evt_tasks)
      }

      return false
    }

    return true
  }

  setIsDebouncing = isDebouncing => {
    this.setState({ isDebouncing })
  }

  hasOnlySingleUnit = unitList => !isEmpty(unitList) && unitList.length === 1

  findLocusByName = findLocusName => {
    const { locusList } = this.props

    return locusList.find(locus => locus.name === findLocusName)
  }

  clearCurrentTask = invalidDates => {
    const { currentTask } = this.state
    const { setInvalidSingleInput, isSingleTask } = this.props
    const newInputs = []

    currentTask.evt_inputs.forEach(input => {
      if (!invalidDates.includes(input.input)) {
        newInputs.push(input)
      }
    })

    this.setState(
      {
        currentTask: {
          ...currentTask,
          evt_inputs: newInputs,
        },
      },
      () => {
        if (isSingleTask) {
          setInvalidSingleInput(!this.isRequiredInputsFilled())
        }
      },
    )
  }

  findLocusGroupByName = findLocusGroupName => {
    const { locusGroupList } = this.props

    return locusGroupList.find(
      locusGroup => locusGroup.name === findLocusGroupName,
    )
  }

  setMultiChoiceMode = multiChoiceMode => {
    this.setState({
      multiChoiceMode,
      multiUnitTaskIds: [],
    })
  }

  setMultiTaskUnits = unitsIds => {
    const { needs_locus, needs_locus_group } = this.props
    const needsLocusList = needs_locus && !needs_locus_group
    const needsLocusGroupList = needs_locus_group && !needs_locus
    let formattedData = []

    if (!isEmpty(unitsIds)) {
      if (needs_locus && needs_locus_group) {
        const groupIdList =
          unitsIds && Object.keys(unitsIds).map(unit => Number(unit))

        formattedData = groupIdList
          .map(groupId => {
            const groupItemSet = unitsIds[groupId]

            return groupItemSet.map(unitId => ({
              locus_group: groupId,
              locus: unitId,
            }))
          })
          .flat()
      }

      if (needsLocusList) {
        const [unitsIdList] = Object.values(unitsIds)

        formattedData = unitsIdList.map(unitId => ({ locus: unitId }))
      }

      if (needsLocusGroupList) {
        formattedData = unitsIds.map(unitId => ({ locus_group: unitId }))
      }
    }

    this.getSuitableMultiTask(formattedData)
  }

  getSuitableMultiTask = formattedData => {
    const { evt_tasks, needs_locus, needs_locus_group } = this.props
    const multiUnitTaskIds = []
    let notExistingUnitTaskIds = []

    if (this.checkData(evt_tasks)) {
      formattedData.forEach(item => {
        const existedEvtTask = evt_tasks.find(
          ({ locus_group, locus }) =>
            (needs_locus &&
              needs_locus_group &&
              item.locus_group === locus_group &&
              item.locus === locus) ||
            (needs_locus_group &&
              !needs_locus &&
              item.locus_group === locus_group) ||
            (needs_locus && !needs_locus_group && item.locus === locus),
        )

        if (existedEvtTask) {
          multiUnitTaskIds.push(existedEvtTask.id)
        } else {
          notExistingUnitTaskIds.push(item)
        }
      })
    } else {
      notExistingUnitTaskIds = [...formattedData]
    }

    this.setState(
      {
        multiUnitTaskIds,
        notExistingUnitTaskIds,
      },
      () => {
        if (!isEmpty(notExistingUnitTaskIds)) {
          this.createEvtMultiTask(notExistingUnitTaskIds)
        }
      },
    )
  }

  createEvtMultiTask = taskUnits => {
    const { id, createEvtJobMultiTask, onJobTaskListRefresh } = this.props
    const { multiUnitTaskIds } = this.state
    let data = {}

    if (!isEmpty(taskUnits)) {
      data = {
        task: id,
        data: taskUnits,
      }
    }

    if (!isEmpty(data)) {
      withPromise(createEvtJobMultiTask, {
        data,
      }).then(response => {
        if (!response.error) {
          this.setState(
            {
              multiUnitTaskIds: [...multiUnitTaskIds, ...response],
              notExistingUnitTaskIds: [],
            },
            () => {
              onJobTaskListRefresh(true)
            },
          )
        }
      })
    }
  }

  setCurrentTaskUnits = (
    stateFieldName,
    value,
    passParams = false,
    shouldGetSuitableTask = true,
  ) => {
    this.setState(
      {
        [stateFieldName]: value,
        currentTask: {},
      },
      () => {
        if (passParams) {
          if (stateFieldName === 'locusGroup') {
            this.checkAvailableEvtTask()

            return
          }

          if (stateFieldName === 'locus') {
            this.getSuitableTask(null, stateFieldName, value)

            return
          }
        }

        if (shouldGetSuitableTask) {
          this.getSuitableTask()
        }
      },
    )
  }

  checkData = data => data && !!data.length

  setCurrentTask = (currentTask = {}) => {
    const { currentTask: oldCurrentTask } = this.state
    let nextTask = currentTask

    if (!isEmpty(oldCurrentTask) && !isEmpty(currentTask)) {
      const propsEvtInputs = currentTask.evt_inputs || []
      const localEvtInputs = oldCurrentTask.evt_inputs || []

      nextTask = {
        ...currentTask,
        evt_inputs: propsEvtInputs.map(evtInput => {
          const localEvtInput = localEvtInputs.find(
            item => item.id === evtInput.id || item.input === evtInput.input,
          )

          if (!localEvtInput?.conditionalItems) {
            return evtInput
          }

          return {
            ...evtInput,
            conditionalItems: mergeConditionalItems(
              localEvtInput.conditionalItems,
              evtInput.conditionalItems,
            ),
          }
        }),
      }

      nextTask.evt_inputs = applyPopulatedEvtInputsToEvtInputs(
        nextTask.evt_inputs,
        localEvtInputs
          .filter(
            localEvtInput =>
              !isEvtInputResultEmpty(localEvtInput.result) &&
              !propsEvtInputs.some(
                propEvtInput =>
                  propEvtInput.id === localEvtInput.id ||
                  propEvtInput.input === localEvtInput.input,
              ),
          )
          .map(({ id, input, result }) => ({ id, input, result })),
      )
    }

    if (
      isEmpty(oldCurrentTask) ||
      isEmpty(nextTask) ||
      nextTask.evt_inputs.length !== oldCurrentTask.evt_inputs.length ||
      !isEqual(nextTask.evt_inputs, oldCurrentTask.evt_inputs)
    ) {
      this.setState({
        currentTask: nextTask,
      })
    }
  }

  handleStaticCalculationInputs = () => {
    const {
      currentTask: { id: currentEvtTaskId },
    } = this.state
    const { input_items } = this.props
    const calculatedInputs = []
    const paramsToEvaluate = []

    input_items.forEach(inputItem => {
      const { input_item_type, inputs, type } = inputItem

      if (type === 'calculated') {
        calculatedInputs.push(inputItem)
      }

      if (input_item_type === 'input_group') {
        inputs.forEach(input => {
          if (input.type === 'calculated') {
            calculatedInputs.push(input)
          }
        })
      }
    })

    const noInputsMatches = calculatedInputs.filter(
      ({ parameters: { formula } }) => !formula.match('"type":"input"'),
    )

    noInputsMatches.forEach(({ id: inputId }) => {
      paramsToEvaluate.push({
        inputId,
        evtTaskIds: [currentEvtTaskId],
      })
    })

    if (paramsToEvaluate.length) {
      this.evaluateSingleCalculationField(paramsToEvaluate)
    }
  }

  setSavingEvtJobEntry = value => {
    this.setState({
      savingEvtJobEntry: value,
    })
  }

  saveEvtJobEntry = () => {
    const {
      id,
      needs_locus,
      needs_locus_group,
      evt_tasks,
      createEvtJobTask,
      fetchJobTaskList,
      activeJob: { id: activeJobId },
      isLoadEvtTask,
      activeJobStatus,
    } = this.props
    const { locusGroup, locus } = this.state
    const checkLocusList = needs_locus && Boolean(locus)
    const checkLocusGroupList = needs_locus_group && Boolean(locusGroup)
    const withoutLocus = !needs_locus && !needs_locus_group
    const data = {}

    if (!needs_locus && checkLocusGroupList) {
      data.task = id
      data.locus_group = locusGroup
    }

    if (!needs_locus_group && checkLocusList) {
      data.task = id
      data.locus = locus
    }

    if (checkLocusList && checkLocusGroupList) {
      data.task = id
      data.locus_group = locusGroup
      data.locus = locus
    }

    if (withoutLocus && !this.checkData(evt_tasks)) {
      data.task = id
    }

    this.setState({ prevTaskId: id })

    if (
      !isEmpty(data) &&
      !isLoadEvtTask &&
      activeJobStatus !== STATUS_COMPLETED
    ) {
      withPromise(createEvtJobTask, {
        data,
      }).then(response => {
        if (!response.error) {
          withPromise(fetchJobTaskList, {
            activeJobId,
          }).then(() => {
            this.setSavingEvtJobEntry(false)
            this.handleStaticCalculationInputs()
          })
        } else {
          this.setSavingEvtJobEntry(false)
        }
      })
    } else {
      this.setSavingEvtJobEntry(false)
    }
  }

  getSuitableTask = (evtTasks, field = null, data = null) => {
    const { needs_locus, needs_locus_group, evt_tasks, state } = this.props
    const { locusGroup, locus } = this.state
    let suitableTask = {}
    const taskList = evtTasks || evt_tasks
    const taskCompleted = state === STATUS_COMPLETED
    const locusField = field === 'locus'
    const locusGroupField = field === 'locusGroup'

    if (this.checkData(taskList)) {
      taskList.forEach(task => {
        if (
          !needs_locus &&
          needs_locus_group &&
          ((task.locus_group === data && locusGroupField) ||
            task.locus_group === locusGroup)
        ) {
          suitableTask = task
        }

        if (
          !needs_locus_group &&
          needs_locus &&
          ((task.locus === data && locusField) || task.locus === locus)
        ) {
          suitableTask = task
        }

        if (
          needs_locus_group &&
          needs_locus &&
          ((task.locus_group === data && locusGroupField) ||
            task.locus_group === locusGroup) &&
          ((task.locus === data && locusField) || task.locus === locus)
        ) {
          suitableTask = task
        }

        if (!needs_locus_group && !needs_locus) {
          suitableTask = task
        }
      })

      if (!isEmpty(suitableTask)) {
        this.setCurrentTask(suitableTask)
      }
    }

    if (isEmpty(suitableTask) && !taskCompleted) {
      this.setSavingEvtJobEntry(true)
      this.saveEvtJobEntry()
    }
  }

  findInputData = id => {
    const { needs_multi_unit } = this.props
    const {
      currentTask: { evt_inputs },
      multiUnitTaskIds,
      multiChoiceMode,
    } = this.state
    let result = {}

    if (needs_multi_unit && multiChoiceMode && !isEmpty(multiUnitTaskIds)) {
      const multiUnitTaskLength = multiUnitTaskIds.length
      const existingEvtTasks = this.findExistingEvtTask(multiUnitTaskIds)

      if (
        existingEvtTasks &&
        existingEvtTasks.length === multiUnitTaskIds.length
      ) {
        result = this.compareEvtInputValues(
          existingEvtTasks,
          id,
          multiUnitTaskLength,
        )
      }
    } else if (this.checkData(evt_inputs)) {
      evt_inputs.forEach(i => {
        if (i.input === id) {
          result.value = i.result
          result.evtInputId = i.id
        }
      })
    }

    return result
  }

  handleUnitsChange = (activeUnitId, shouldStayOpened) => {
    const {
      activeUnits: stateActiveUnits,
      activeUnitId: stateActiveUnitId,
    } = this.state
    const stateObj = {
      activeUnitId,
      activeUnits: {
        ...stateActiveUnits,
      },
    }
    const { activeUnits } = stateObj

    if (stateActiveUnits[activeUnitId] === 'open' && !shouldStayOpened) {
      activeUnits[activeUnitId] = 'close'
    } else {
      if (stateActiveUnitId) {
        activeUnits[stateActiveUnitId] = 'close'
      }

      activeUnits[activeUnitId] = 'open'
    }

    this.setState({ ...stateObj })
  }

  getAllInputs = () => {
    const { input_items } = this.props

    const inputs = input_items.filter(
      ({ input_item_type }) => input_item_type === 'input',
    )
    const inputGroups = input_items.filter(
      ({ input_item_type }) => input_item_type === 'input_group',
    )

    let inputGroupsInputs = []

    if (inputGroups.length) {
      inputGroups.forEach(({ inputs }) => {
        inputGroupsInputs = [...inputGroupsInputs, ...inputs]
      })
    }

    return [...inputGroupsInputs, ...inputs]
  }

  getValueForPreviewInput = (result, type, options) => {
    let value

    if (type === TYPE_SELECT) {
      if (typeof result !== 'string') {
        value =
          result === null
            ? ''
            : result
                .map(value => {
                  if (options[value]) {
                    return options[value]
                  }

                  const parts = value.split('_')

                  if (parts) {
                    const internalPartsCount = parts.includes('dynamic')
                      ? PREVIEW_WITH_DYNAMIC_INTERNAL_PARTS_COUNT
                      : PREVIEW_INTERNAL_PARTS_COUNT

                    return parts.length > 2
                      ? parts.slice(internalPartsCount).join('_')
                      : parts[1]
                  }

                  return ''
                })
                .join(', ')
      } else if (options[result]) {
        value = options[result]
      } else {
        const parts = result.split('_')

        if (parts) {
          value =
            parts.length > 2
              ? parts.slice(1).join('_')
              : options[parts[1]] || options[parts[0]] || parts[1] || parts[0]
        } else {
          value = ''
        }
      }
    } else {
      value = result
    }

    return value
  }

  // eslint-disable-next-line max-statements
  setNewEvtTask = (
    { evtInputId, evt_task, result, input, file },
    { id, conditionalItems },
  ) => {
    const { currentTask } = this.state
    const {
      setInvalidSingleInput,
      isSingleTask,
      previewInputs,
      setPreviewInputs,
      updateTaskPreviewInputs,
      activeJob,
      featureFlags,
      preview_inputs: taskPreviewInputs,
    } = this.props
    const { evt_inputs: currentEvtInputs = [] } = currentTask
    const populatedEvtInputs = conditionalItems?.populatedEvtInputs || []
    const clearedPopulatedEvtInputIds =
      conditionalItems?.clearedPopulatedEvtInputIds || []
    let evt_inputs = currentEvtInputs

    const { preview, short_name, title, type, options } =
      this.getAllInputs().find(({ id: inputId }) => input === inputId) || {}

    if (preview) {
      const value = this.getValueForPreviewInput(result, type, options)
      const newPreview = {
        short_name,
        title,
        type,
        value,
        evt_input_id: id,
        jobId: activeJob.id,
      }
      const index = previewInputs.findIndex(
        ({ evt_input_id }) => evt_input_id === evtInputId,
      )

      if (index >= 0) {
        const newInputs = [...previewInputs]
        newInputs[index].value = value

        setPreviewInputs([...newInputs])
      } else {
        setPreviewInputs([...previewInputs, newPreview])
      }
    }

    const isInputInPreviewTask = taskPreviewInputs?.some(
      previewInput => previewInput.input_id === input,
    )

    if (isInputInPreviewTask) {
      const value = this.getValueForPreviewInput(result, type, options)
      const newPreview = {
        short_name,
        title,
        type,
        value,
        evt_input_id: id,
      }

      const index = taskPreviewInputs.findIndex(
        ({ evt_input_id }) => evt_input_id === evtInputId,
      )

      if (index >= 0) {
        const newInputs = [...taskPreviewInputs]
        newInputs[index].value = value

        updateTaskPreviewInputs({ taskId: id, previewInputs: [...newInputs] })
      } else {
        updateTaskPreviewInputs({
          taskId: id,
          previewInputs: [...taskPreviewInputs, newPreview],
        })
      }
    }

    if (Array.isArray(evt_inputs)) {
      if (evtInputId) {
        evt_inputs.forEach(item => {
          /* eslint-disable no-param-reassign */
          if (item.id === id) {
            item.result = file || result
            if (conditionalItems && featureFlags.CONDITIONAL_INPUTS) {
              item.conditionalItems = mergeConditionalItems(
                item.conditionalItems,
                conditionalItems,
              )
            }
          } else if (item.conditionalItems) {
            const { inputs, inputGroups } = conditionalItems || {}
            const allConditionalItemsIds = getConditionalItemsIds(inputs)
            const allConditionalItemGroupsIds = getConditionalItemsIds(
              inputGroups,
            )

            const {
              conditionalItems: {
                inputs: {
                  available: itemInputsAvailable = [],
                  hidden: itemInputsHidden = [],
                } = {},
                inputGroups: {
                  available: itemGroupsAvailable = [],
                  hidden: itemGroupsHidden = [],
                } = {},
              },
            } = item

            if (itemInputsAvailable.length) {
              item.conditionalItems.inputs.available = filterConditionalItems(
                itemInputsAvailable,
                allConditionalItemsIds,
              )
            }

            if (itemInputsHidden.length) {
              item.conditionalItems.inputs.hidden = filterConditionalItems(
                itemInputsHidden,
                allConditionalItemsIds,
              )
            }

            if (itemGroupsAvailable.length) {
              item.conditionalItems.inputGroups.available = filterConditionalItems(
                itemGroupsAvailable,
                allConditionalItemGroupsIds,
              )
            }

            if (itemGroupsHidden.length) {
              item.conditionalItems.inputGroups.hidden = filterConditionalItems(
                itemGroupsHidden,
                allConditionalItemGroupsIds,
              )
            }
          }

          if (
            featureFlags.CONDITIONAL_INPUTS &&
            conditionalItems?.clearedConditionalEvtInputIds?.includes(item.id)
          ) {
            delete item.result
          }
          /* eslint-enable no-param-reassign */
        })
      }

      if (evt_task) {
        const index = evt_inputs.findIndex(
          ({ id: evtInputId }) => id === evtInputId,
        )
        const existingEvtInput = evt_inputs[index]
        const newEvtInput = {
          id,
          result: file || result,
          input,
          ...(conditionalItems && featureFlags.CONDITIONAL_INPUTS
            ? {
                conditionalItems: mergeConditionalItems(
                  existingEvtInput?.conditionalItems,
                  conditionalItems,
                ),
              }
            : {}),
        }

        if (index >= 0) {
          evt_inputs[index] = newEvtInput
        } else {
          evt_inputs.push(newEvtInput)
        }
      }

      evt_inputs = clearPopulatedEvtInputsFromEvtInputs(
        featureFlags.CONDITIONAL_INPUTS ? evt_inputs : [],
        featureFlags.CONDITIONAL_INPUTS ? clearedPopulatedEvtInputIds : [],
      )

      evt_inputs = applyPopulatedEvtInputsToEvtInputs(
        featureFlags.CONDITIONAL_INPUTS ? evt_inputs : [],
        featureFlags.CONDITIONAL_INPUTS ? populatedEvtInputs : [],
      )

      this.setState(
        {
          currentTask: {
            ...currentTask,
            evt_inputs,
          },
        },
        () => {
          if (isSingleTask) {
            setInvalidSingleInput(!this.isRequiredInputsFilled())
          }
        },
      )
    }
  }

  isInputValueExist = (requiredInputs, arr, field = 'locus_group') => {
    const { evt_tasks } = this.props

    return requiredInputs.every(({ id, parameters, duplicate_context }) => {
      const isCheckbox =
        parameters &&
        Object.prototype.hasOwnProperty.call(parameters, 'display') &&
        parameters.display === 'checkbox'

      return arr.every(item => {
        const { evt_inputs } =
          evt_tasks.find(evt_task => {
            const checkLocusGroup = item.locusGroupId
              ? item.locusGroupId === evt_task.locus_group
              : true

            return evt_task[field] === item.id && checkLocusGroup
          }) || {}

        if (!evt_inputs || (evt_inputs && !evt_inputs.length)) {
          return false
        }

        return evt_inputs.find(({ result, input }) => {
          const hasValue = result || result === 0 || result === false
          const equalInput = input === id

          if (
            !isEmpty(duplicate_context) &&
            duplicate_context[field] !== item.id
          ) {
            return true
          }

          const isInputMatches =
            equalInput && !isEmpty(duplicate_context)
              ? duplicate_context[field] === item.id
              : equalInput

          if (isInputMatches) {
            return isCheckbox ? result : hasValue
          }

          return false
        })
      })
    })
  }

  isRequiredInputsFilled = () => {
    const {
      input_items,
      evt_tasks,
      needs_locus,
      needs_locus_group,
      locusList,
      locusGroupList,
    } = this.props
    const inputs = []
    const {
      currentTask: { evt_inputs, id: evtTaskId },
    } = this.state
    input_items.forEach(item => {
      if (item.input_item_type === 'input') {
        inputs.push(item)
      } else {
        const inputGroupAvailability = !canRenderConditionalInputOrGroup(
          evt_inputs,
          item.parameters,
          item.availability,
          evtTaskId,
          item.id,
          CONDITIONAL_ITEM_TYPE.INPUT_GROUPS,
        )
        if (inputGroupAvailability) {
          item.inputs.forEach(input => {
            if (!isEmpty(item.duplicate_context)) {
              // eslint-disable-next-line no-param-reassign
              input.duplicate_context = item.duplicate_context
            }

            inputs.push(input)
          })
        }
      }
    })

    const requiredInputs = inputs.filter(
      input =>
        input.required &&
        !canRenderConditionalInputOrGroup(
          evt_inputs,
          input.parameters,
          input.availability,
          evtTaskId,
          input.id,
          CONDITIONAL_ITEM_TYPE.INPUTS,
        ),
    )

    if (needs_locus && needs_locus_group) {
      const list = locusGroupList.reduce((result, group) => {
        group.locuses.forEach(locus => {
          // eslint-disable-next-line no-param-reassign
          locus.locusGroupId = group.id
        })

        return [...result, ...group.locuses]
      }, [])

      return this.isInputValueExist(requiredInputs, list, 'locus')
    }

    if (needs_locus && !needs_locus_group) {
      return this.isInputValueExist(requiredInputs, locusList, 'locus')
    }

    if (!needs_locus && needs_locus_group) {
      return this.isInputValueExist(
        requiredInputs,
        locusGroupList,
        'locus_group',
      )
    }

    if (!needs_locus && !needs_locus_group) {
      return requiredInputs.every(({ id, parameters }) => {
        const isCheckbox =
          parameters &&
          Object.prototype.hasOwnProperty.call(parameters, 'display') &&
          parameters.display === 'checkbox'

        return evt_tasks.some(evtTask =>
          evtTask.evt_inputs.some(({ result, input }) => {
            const hasValue = result || result === 0 || result === false

            if (input === id) {
              return isCheckbox ? result : hasValue
            }

            return false
          }),
        )
      })
    }
  }

  handleDuplicateInputGroup = (
    // eslint-disable-next-line @typescript-eslint/default-param-last
    insert = DUPLICATE_INSERT_PARAMETER_AFTER,
    // eslint-disable-next-line @typescript-eslint/default-param-last
    action = ACTION_DUPLICATE,
    id,
    payloadLocus,
    payloadLocusGroup,
  ) => {
    const {
      activeJob: { id: activeJobId },
      duplicateInputGroup,
      fetchJobTaskList,
      onJobListRefresh,
    } = this.props

    withPromise(duplicateInputGroup, {
      id,
      action,
      data: {
        insert,
        locus: payloadLocus,
        locus_group: payloadLocusGroup,
      },
    }).then(response => {
      if (!response.error) {
        fetchJobTaskList({
          activeJobId,
        })
        onJobListRefresh(true)
      }
    })
  }

  onJobTaskValueRange = valueOutOfRange => {
    const { setOutOfRange, isSingleTask } = this.props

    if (isSingleTask && valueOutOfRange !== undefined) {
      setOutOfRange(valueOutOfRange)
    }

    this.setState({ valueOutOfRange })
  }

  extractFormulaIds = ({ parameters: { formula } }) =>
    formula
      .match(/"id":[\d]\w+((?!\[\[).)*"type":"input"/g)
      .map(item => +item.split(',')[0].replace('"id":', ''))

  checkFilledFormulaFields = (formulaNumberIds, evt_inputs) =>
    formulaNumberIds.every(
      numberInputId =>
        evt_inputs &&
        evt_inputs.find(
          ({ input, result }) =>
            numberInputId === input && (!!result || result === 0),
        ),
    )

  evaluateSingleCalculationField = paramsToEvaluate => {
    const {
      currentTask: { evt_inputs },
    } = this.state
    const {
      evaluateCalculationFields,
      updateJobTaskInput,
      saveJobTaskInput,
      onJobTaskListRefresh,
    } = this.props

    withPromise(evaluateCalculationFields, paramsToEvaluate).then(
      responseArr => {
        if (responseArr && responseArr.length) {
          let jobAction

          responseArr.forEach(({ inputId, response }) => {
            response.forEach(({ value: result, evt_task }) => {
              const { id: evtInputId } =
                evt_inputs.find(({ input }) => input === inputId) || {}
              const data = {
                evtInputId,
                result,
                input: inputId,
              }

              if (evtInputId) {
                jobAction = updateJobTaskInput
              } else {
                jobAction = saveJobTaskInput
                data.evt_task = evt_task
              }

              withPromise(jobAction, { data }).then(jobActionResponse => {
                this.setNewEvtTask(data, jobActionResponse)
                onJobTaskListRefresh(true)
              })
            })
          })
        }
      },
    )
  }

  handleCalculationFields = ({ matchCalculationFields }) => {
    const {
      currentTask: { id, evt_inputs },
    } = this.state
    const paramsToEvaluate = []

    matchCalculationFields.forEach(calculationField => {
      const formulaNumberIds = this.extractFormulaIds(calculationField)
      const allFormulaFieldsFilled = this.checkFilledFormulaFields(
        formulaNumberIds,
        evt_inputs,
      )

      if (allFormulaFieldsFilled) {
        paramsToEvaluate.push({
          inputId: calculationField.id,
          evtTaskIds: [id],
        })
      }
    })

    if (paramsToEvaluate.length) {
      this.evaluateSingleCalculationField(paramsToEvaluate)
    }
  }

  handleMultipleCalculationFields = matchCalculationFields => {
    const { multiUnitTaskIds } = this.state
    const {
      evt_tasks,
      evaluateCalculationFields,
      updateJobTaskInput,
      onJobTaskListRefresh,
      saveJobTaskInput,
    } = this.props
    const paramsToEvaluate = []

    const currentEvtTasks = evt_tasks.filter(({ id: taskId }) =>
      multiUnitTaskIds.find(id => id === taskId),
    )

    currentEvtTasks.forEach(({ id, evt_inputs }) => {
      matchCalculationFields.forEach(calculationField => {
        const formulaNumberIds = this.extractFormulaIds(calculationField)
        const allFormulaFieldsFilled = this.checkFilledFormulaFields(
          formulaNumberIds,
          evt_inputs,
        )

        if (allFormulaFieldsFilled) {
          const fieldMatch = paramsToEvaluate.find(
            ({ inputId }) => inputId === calculationField.id,
          )

          if (fieldMatch) {
            fieldMatch.evtTaskIds.push(id)
          } else {
            paramsToEvaluate.push({
              inputId: calculationField.id,
              evtTaskIds: [id],
            })
          }
        }
      })
    })

    if (paramsToEvaluate.length) {
      withPromise(evaluateCalculationFields, paramsToEvaluate).then(
        responseArr => {
          if (responseArr && responseArr.length) {
            let jobAction

            responseArr.forEach(({ inputId, response }) => {
              response.forEach(({ value: result, evt_task }) => {
                const { evt_inputs } = evt_tasks.find(
                  ({ id }) => id === +evt_task,
                )
                const { id: evtInputId } =
                  evt_inputs.find(({ input }) => input === inputId) || {}
                const data = {
                  evtInputId,
                  result,
                  input: inputId,
                }

                if (evtInputId) {
                  jobAction = updateJobTaskInput
                } else {
                  jobAction = saveJobTaskInput
                  data.evt_task = evt_task
                }

                withPromise(jobAction, { data }).then(() => {
                  onJobTaskListRefresh(true)
                })
              })
            })
          }
        },
      )
    }
  }

  // eslint-disable-next-line @typescript-eslint/default-param-last
  onJobTaskAutoSave = (data = false, callback, errorHandler) => {
    const {
      state,
      saveJobTaskInput,
      updateJobTaskInput,
      saveJobMultiTaskInputs,
      updateJobMultiTaskInputs,
      onJobTaskListRefresh,
      clearEvtInputsResults,
      needs_multi_unit,
      input_items,
      id: taskId,
    } = this.props
    const { setResultId, result, matchCalculationFields } = data
    const { currentTask, multiUnitTaskIds, multiChoiceMode } = this.state
    const { id } = currentTask
    let jobAction

    if (!data) {
      this.setState({ isFocusedInput: false })

      if (callback) {
        callback()
      }

      return
    }

    if (needs_multi_unit && multiChoiceMode) {
      const [
        existingEvtInputsId,
        notExistingEvtInputs,
      ] = this.checkAvailableMultiTasks(multiUnitTaskIds, data.input)

      if (!isEmpty(notExistingEvtInputs)) {
        const evtTaskList = notExistingEvtInputs.map(id => ({ evt_task: id }))
        const queryData = {
          ...data,
          setResultId,
          data: evtTaskList,
        }

        if (!isEmpty(existingEvtInputsId)) {
          this.jobMultiTaskInputsUpdateQuery(
            queryData,
            existingEvtInputsId,
            matchCalculationFields,
            callback,
          )
        } else {
          this.jobMultiTaskInputsQuery(
            saveJobMultiTaskInputs,
            queryData,
            true,
            matchCalculationFields,
            callback,
          )
        }
      } else if (!isEmpty(existingEvtInputsId)) {
        const queryData = {
          evt_inputs: existingEvtInputsId,
          result,
          setResultId,
        }

        this.jobMultiTaskInputsQuery(
          updateJobMultiTaskInputs,
          queryData,
          true,
          matchCalculationFields,
          callback,
        )
      } else if (callback) {
        callback()
      }
    } else {
      if (data.evtInputId) {
        jobAction = updateJobTaskInput
      } else {
        // eslint-disable-next-line no-param-reassign
        data.evt_task = id
        jobAction = saveJobTaskInput
      }

      if (jobAction) {
        withPromise(jobAction, {
          data: {
            ...data,
            updatedGroup: (
              input_items.find(
                item =>
                  item.input_item_type === 'input_group' &&
                  item.inputs.some(inputItem => data.input === inputItem.id),
              ) || {}
            ).id,
          },
          currentTaskID: taskId,
          currentEvtTaskID: id,
        }).then(response => {
          if (!response.error) {
            if (Object.prototype.hasOwnProperty.call(data, 'setResultId')) {
              data.setResultId(response)
              this.setNewEvtTask(data, response)

              if (state === STATUS_NOT_STARTED) {
                let inputItem

                input_items.forEach(input_item => {
                  if (
                    input_item.input_item_type === 'input_group' &&
                    input_item.inputs.length
                  ) {
                    inputItem = input_item.inputs.find(
                      input => input.id === data.input,
                    )
                  } else if (input_item.id === data.input) {
                    inputItem = input_item
                  }
                })

                onJobTaskListRefresh(
                  inputItem && inputItem.type !== TYPE_INPUT_BOOLEAN,
                )
              }
            }

            if (response.clearedDependentEvtInputIds?.length) {
              // onJobTaskListRefresh(true)
              clearEvtInputsResults({
                currentTaskID: taskId,
                currentEvtTaskID: id,
                clearedEvtInputs: response.clearedDependentEvtInputIds,
              })
            }

            if (
              data.matchCalculationFields &&
              data.matchCalculationFields.length
            ) {
              this.handleCalculationFields(data)
            }
          } else if (errorHandler) {
            errorHandler(response)
          }

          if (callback) {
            callback()
          }

          this.setState({ isFocusedInput: false })
        })
      } else if (callback) {
        callback()
      }
    }
  }

  compareEvtInputValues = (evtTasks, inputId, multiUnitTaskLength) => {
    const result = {}
    const existingEvtInputs = []
    const existingEvtInputIds = []
    let existingEvtInputsValue
    let valueIsEqual = false

    if (!isEmpty(evtTasks)) {
      evtTasks.forEach(({ evt_inputs }) => {
        if (!isEmpty(evt_inputs)) {
          evt_inputs.forEach(evtInput => {
            if (evtInput && evtInput.input === inputId) {
              existingEvtInputs.push(evtInput)
            }
          })
        }
      })
    }

    if (!isEmpty(existingEvtInputs)) {
      valueIsEqual = existingEvtInputs.every(({ result, id }, index) => {
        if (index === 0) {
          existingEvtInputsValue = result
        }

        existingEvtInputIds.push(id)

        if (existingEvtInputs.length !== multiUnitTaskLength) {
          return false
        }

        return isEqual(existingEvtInputsValue, result)
      })
    }

    result.value = valueIsEqual ? existingEvtInputsValue : undefined
    result.evtInputId = existingEvtInputIds
    result.valueIsEqual = isEmpty(existingEvtInputIds)
      ? undefined
      : valueIsEqual

    return result
  }

  findExistingEvtTask = multiUnitTaskIds => {
    const { evt_tasks } = this.props
    const existingEvtTasks = []

    evt_tasks.forEach(evtTask => {
      multiUnitTaskIds.forEach(unitTaskId => {
        if (evtTask.id === unitTaskId) {
          existingEvtTasks.push(evtTask)
        }
      })
    })

    return existingEvtTasks
  }

  checkAvailableMultiTasks = (multiUnitTaskIds, inputData) => {
    const existingEvtInputsId = []
    const existingEvtTaskInputsId = []
    const existingEvtTasks = this.findExistingEvtTask(multiUnitTaskIds)

    if (!isEmpty(existingEvtTasks)) {
      existingEvtTasks.forEach(({ id, evt_inputs }) => {
        if (!isEmpty(evt_inputs)) {
          evt_inputs.forEach(evtInput => {
            if (evtInput && evtInput.input === inputData) {
              existingEvtInputsId.push(evtInput.id)
              existingEvtTaskInputsId.push(id)
            }
          })
        }
      })
    }

    const evtTaskList = multiUnitTaskIds.filter(
      item => !existingEvtTaskInputsId.includes(item),
    )

    return [existingEvtInputsId, evtTaskList]
  }

  jobMultiTaskInputsQuery = (
    action,
    data,
    update,
    matchCalculationFields,
    callback,
  ) => {
    const { state, onJobTaskListRefresh } = this.props

    if (data) {
      withPromise(action, {
        data,
      }).then(response => {
        if (
          !response.error &&
          Object.prototype.hasOwnProperty.call(data, 'setResultId')
        ) {
          data.setResultId({ id: response })

          if (
            (!matchCalculationFields || !matchCalculationFields.length) &&
            (update || state === STATUS_NOT_STARTED)
          ) {
            onJobTaskListRefresh(true)
          }

          if (matchCalculationFields && matchCalculationFields.length) {
            withPromise(onJobTaskListRefresh, true).then(() => {
              this.handleMultipleCalculationFields(matchCalculationFields)
            })
          }

          if (callback) {
            callback()
          }
        }

        this.setState({ isFocusedInput: false })
      })
    }
  }

  jobMultiTaskInputsUpdateQuery = (
    data,
    existingEvtInputsId,
    matchCalculationFields,
    callback,
  ) => {
    const {
      saveJobMultiTaskInputs,
      updateJobMultiTaskInputs,
      onJobTaskListRefresh,
    } = this.props

    if (data) {
      withPromise(saveJobMultiTaskInputs, {
        data,
      }).then(response => {
        if (
          !response.error &&
          Object.prototype.hasOwnProperty.call(data, 'setResultId')
        ) {
          const unitedEvtInputsId = [...response, ...existingEvtInputsId]
          const queryData = {
            evt_inputs: unitedEvtInputsId,
            result: data.result,
            setResultId: data.setResultId,
          }

          onJobTaskListRefresh(true)

          this.jobMultiTaskInputsQuery(
            updateJobMultiTaskInputs,
            queryData,
            true,
            matchCalculationFields,
            callback,
          )
        }

        this.setState({ isFocusedInput: false })
      })
    }
  }

  onJobTaskClickHandler = taskId => {
    const {
      needs_locus,
      needs_locus_group,
      evt_tasks,
      onJobTaskClick,
      locusList,
      locusGroupList,
    } = this.props
    const withoutLocus = !needs_locus && !needs_locus_group

    if (withoutLocus && !this.checkData(evt_tasks)) {
      this.getSuitableTask()
    }

    if (needs_locus_group || (!needs_locus_group && needs_locus)) {
      const [{ id: locusId }] = locusList.length ? locusList : [{}]
      const [{ id: groupId }] = locusGroupList.length ? locusGroupList : [{}]
      let itemId = locusId
      let itemType = 'locus'

      if (needs_locus_group && groupId) {
        itemId = groupId
        itemType = 'locusGroup'
      }

      if (
        (needs_locus_group &&
          locusGroupList.length === 1 &&
          (locusList.length > 1 || !locusId)) ||
        locusList.length === 1
      ) {
        this.handleUnitsChange(itemId, true)
        this.setCurrentTaskUnits(itemType, itemId, true)
      }
    }

    onJobTaskClick(taskId)
  }

  getStatusIcon = () => {
    const { state } = this.props
    let type = 'base'

    switch (state) {
      case STATUS_COMPLETED:
        type = 'complete'
        break
      case STATUS_IN_PROGRESS:
        type = 'in_progress'
        break
      default:
        break
    }

    return <StatusIcon type={type} />
  }

  onOpenConfirmDialog = params => {
    this.setState({
      ...params,
      isDialogOpen: true,
    })
  }

  onCloseConfirmDialog = () => {
    this.setState({
      isDialogOpen: false,
      isExtraMenuOpen: false,
    })
  }

  onJobTaskUpdate = async action => {
    const {
      id,
      activeJob: { id: jobId },
      showNotice,
      updateJobTask,
      onJobTaskListRefresh,
      handleTaskStatusChange,
      intl: { formatMessage },
    } = this.props
    const { valueOutOfRange } = this.state
    let isDisabledInput = false

    if (valueOutOfRange) {
      showNotice({
        notice: NoticeHelper.createErrorObj(
          formatMessage(messages.valueOutOfRange),
        ),
      })

      return
    }

    if (action === 'complete') {
      isDisabledInput = true
    }

    this.setState({ isDisabledInput }, () => {
      withPromise(updateJobTask, {
        action,
        params: {
          id,
          jobId,
        },
      }).then(res => {
        this.setState(
          {
            isDisabledInput: false,
          },
          () => {
            if (res && res.errors) {
              this.setState({
                errors: res.errors,
              })

              return Promise.resolve(res.errors)
            }

            onJobTaskListRefresh()
            handleTaskStatusChange(action)
          },
        )
      })
    })

    this.onCloseConfirmDialog()
    this.onCloseMenuExtra()
  }

  onJobTaskDelete = () => {
    const {
      id,
      deleteTask,
      onJobTaskListRefresh,
      onJobListRefresh,
      activeJob: { id: jobId },
    } = this.props
    const {
      currentTask: { evt_inputs },
    } = this.state

    const previewInputs = this.getAllInputs()
      ?.filter(({ preview }) => preview)
      .map(({ id }) => id)
    const previewsToRemove = evt_inputs
      ?.filter(({ input }) => previewInputs.find(id => id === input))
      .map(({ id }) => id)

    withPromise(deleteTask, {
      id,
      jobId,
      previewsToRemove,
    }).then(res => {
      if (res && res.errors) {
        return Promise.resolve(res.errors)
      }

      onJobListRefresh()
      onJobTaskListRefresh()
    })

    this.onCloseMenuExtra()
    this.onCloseConfirmDialog()
  }

  getPopupDataSet = (popupAction, actionName, customTitle = '') => {
    if (!actionName && typeof popupAction !== 'function') return

    const {
      intl: { formatMessage },
      title,
      index,
    } = this.props
    const message =
      actionName &&
      Object.prototype.hasOwnProperty.call(messages, actionName) &&
      formatMessage(messages[actionName])
    const customPopupTitle =
      customTitle &&
      Object.prototype.hasOwnProperty.call(messages, customTitle) &&
      formatMessage(messages[customTitle])
    const standardPopupTitle =
      Object.prototype.hasOwnProperty.call(messages, `${actionName}Task`) &&
      formatMessage(messages[`${actionName}Task`])
    const popupTitle = standardPopupTitle || customPopupTitle
    const entryTitle = `${index} ${title}`

    return {
      popupAction,
      popupTitle,
      popupMessage: (
        <FormattedMessage
          {...messages.confirmTaskMessage}
          values={{
            action: message && message.toLowerCase(),
            entry: <strong>{entryTitle}</strong>,
          }}
        />
      ),
    }
  }

  onJobTaskFocusedInput = isFocusedInput => {
    this.setState({ isFocusedInput })
  }

  getTaskButton = () => {
    const { state, activeJobStatus, isSingleTask, id } = this.props

    if (isSingleTask) {
      return null
    }

    const { isFocusedInput } = this.state
    const taskStatusCompleted = state === STATUS_COMPLETED
    const jobStatusCompleted =
      activeJobStatus === STATUS_COMPLETED ||
      (!taskStatusCompleted && !this.isRequiredInputsFilled())
    const actionName = taskStatusCompleted ? REOPEN_ITEM : COMPLETE_ITEM
    const popupAction = () => this.onJobTaskUpdate(actionName)
    const btnTitle = taskStatusCompleted
      ? messages.reopenTask
      : messages.completeTask

    return (
      <Button
        key={id}
        fullWidth
        href={null}
        color="primary"
        size="large"
        variant="contained"
        type="button"
        className={cn('complete-job', {
          'job-task-completed': jobStatusCompleted,
        })}
        disabled={jobStatusCompleted || isFocusedInput}
        onClick={popupAction}>
        <FormattedMessage {...btnTitle} />
      </Button>
    )
  }

  getFieldValidation = () => {
    const {
      state,
      activeJobStatus,
      needs_locus,
      needs_locus_group,
      isLoadEvtTask,
    } = this.props
    const { locusGroup, locus, multiChoiceMode, multiUnitTaskIds } = this.state
    const jobAndTaskStatus =
      activeJobStatus === STATUS_COMPLETED || state === STATUS_COMPLETED
    const checkLocusList = needs_locus && Boolean(locus)
    const checkLocusGroupList = needs_locus_group && Boolean(locusGroup)
    let result = true

    if (
      multiChoiceMode &&
      !isEmpty(multiUnitTaskIds) &&
      !jobAndTaskStatus &&
      !isLoadEvtTask
    ) {
      return false
    }

    if (
      ((checkLocusList && checkLocusGroupList) ||
        (!needs_locus_group && checkLocusList) ||
        (!needs_locus && checkLocusGroupList) ||
        (!needs_locus_group && !needs_locus)) &&
      !jobAndTaskStatus &&
      !isLoadEvtTask
    ) {
      result = false
    }

    return result
  }

  checkAvailableEvtTask = () => {
    const {
      evt_tasks,
      locusGroupList,
      needs_locus,
      needs_locus_group,
    } = this.props
    const { locusGroup } = this.state

    if (this.checkData(evt_tasks)) {
      const oneGroupTasks = evt_tasks.filter(
        ({ locus_group }) => locus_group === locusGroup,
      )
      const [taskLocusGroup] = locusGroupList.filter(
        ({ id }) => id === locusGroup,
      )
      const hasOnlyOneLocus =
        taskLocusGroup.locuses && taskLocusGroup.locuses.length === 1
      if (!isEmpty(oneGroupTasks)) {
        const oneGroupTasksLength = oneGroupTasks.length
        const { locus, locus_group } =
          oneGroupTasksLength > 1
            ? oneGroupTasks[oneGroupTasksLength - 1]
            : oneGroupTasks[0]
        const currentLocus = () => {
          const { locuses } =
            locusGroupList.find(({ id }) => id === locus_group) || {}
          let locusId = null

          if (locuses && locuses.length) {
            const { id } = locuses.find(({ id }) => id === locus) || {}
            locusId = id
          }

          return locusId
        }

        this.setState(
          {
            locus: currentLocus(),
            locusGroup: locus_group,
          },
          () => {
            this.getSuitableTask()
          },
        )
      } else if (!hasOnlyOneLocus || (needs_locus_group && !needs_locus)) {
        this.setState(
          {
            locus: null,
          },
          () => {
            this.getSuitableTask(null, 'locusGroup', locusGroup)
          },
        )
      }
    } else {
      this.getSuitableTask(null, 'locusGroup', locusGroup)
    }
  }

  renderUsers() {
    const {
      assigned_users,
      profileName,
      intl: { formatMessage },
    } = this.props
    const renderUsers = {
      renderCurrentUser: [],
      renderOtherUsers: [],
    }

    assigned_users.forEach(({ id, name, matches_me }) => {
      if (matches_me && name.toLowerCase() === profileName.toLowerCase()) {
        renderUsers.renderCurrentUser.push(
          <li key={id} className={cn({ active: matches_me })}>
            {formatMessage(messages.me)}
          </li>,
        )
      } else {
        renderUsers.renderOtherUsers.push(<li key={id}>{name}</li>)
      }
    })

    return renderUsers
  }

  renderUsersGroups() {
    return this.props.assigned_user_groups.map(({ id, name, matches_me }) => {
      const groupImg = !matches_me ? (
        <UsersGroupIcon />
      ) : (
        <ActiveUsersGroupIcon />
      )

      return (
        <li key={id} className={cn({ active: matches_me })}>
          {groupImg} {name}
        </li>
      )
    })
  }

  renderProperList() {
    const { renderCurrentUser, renderOtherUsers } = this.renderUsers()

    return [
      ...renderCurrentUser,
      ...this.renderUsersGroups(),
      ...renderOtherUsers,
    ]
  }

  onOpenExtraMenu = event => {
    event.stopPropagation()

    if (ifWindowWidthLessThan(LAPTOP_BREAKPOINT)) {
      this.setState(prevState => ({
        isExtraMenuOpen: !prevState.isExtraMenuOpen,
      }))
    } else {
      this.setState({ anchor: event.currentTarget })
    }
  }

  onCloseMenuExtra = () => {
    this.setState({ anchor: null })
  }

  onCloseDrawerExtra = () => {
    this.setState({ isExtraMenuOpen: false })
  }

  onOpenReassignDialog = reassignType => {
    this.setState(
      {
        isExtraMenuOpen: false,
        isOpenReassignDialog: true,
        reassignType,
      },
      () => {
        this.onCloseMenuExtra()
      },
    )
  }

  onCloseReassignDialog = () => {
    this.setState({
      isOpenReassignDialog: false,
      reassignType: null,
    })
  }

  getExtraMenuList = actionName => {
    if (!actionName) return
    const {
      state,
      activeJobStatus,
      intl: { formatMessage },
    } = this.props
    const menuItem = {
      text:
        actionName && Object.prototype.hasOwnProperty.call(messages, actionName)
          ? formatMessage(messages[actionName])
          : actionName,
      icon: null,
      onClick: FuncHelper.emptyFunc(),
    }

    switch (actionName) {
      case REOPEN_ITEM:
        menuItem.icon = <Replay />
        break
      case COMPLETE_ITEM: {
        menuItem.icon = <CheckCircleOutline />
        break
      }
      case DELETE_ITEM: {
        const popupDataSet = this.getPopupDataSet(
          this.onJobTaskDelete,
          actionName,
        )
        menuItem.icon = <HighlightOff />
        menuItem.onClick = () => this.onOpenConfirmDialog(popupDataSet)
        break
      }
      case DUPLICATE_ITEM:
        menuItem.icon = <DuplicateIcon />
        menuItem.disabled = activeJobStatus === STATUS_COMPLETED
        menuItem.onClick = () => this.onJobTaskUpdate(actionName)
        break
      case DUPLICATE_ITEM_WITH_DATA:
        menuItem.icon = <DuplicateIcon />
        menuItem.disabled = activeJobStatus === STATUS_COMPLETED
        menuItem.onClick = () =>
          this.onJobTaskUpdate(ACTION_DUPLICATE_WITH_DATA)
        break
      case REASSIGN_ITEM:
      case REASSIGN_SERIES:
        menuItem.icon = <PersonOutlined />
        menuItem.onClick = () => {
          this.onOpenReassignDialog(actionName)
        }
        menuItem.disabled = state === STATUS_COMPLETED
        break
      default:
        break
    }

    return (
      <ListItem
        button
        data-action={actionName}
        onClick={menuItem.onClick}
        disabled={!!menuItem.disabled}>
        <ListItemIcon>{menuItem.icon}</ListItemIcon>
        <ListItemText>{menuItem.text}</ListItemText>
      </ListItem>
    )
  }

  getLocusListData = () => {
    const {
      needs_locus,
      needs_locus_group,
      locusList,
      locusGroupList,
    } = this.props
    const { locusGroup } = this.state
    const { locuses = [] } =
      !!locusGroup && locusGroupList.find(item => item.id === locusGroup)
    let result = locusList

    if (
      needs_locus_group &&
      needs_locus &&
      locusGroup &&
      locuses &&
      locuses.length > 0
    ) {
      result = locuses
    }

    return result
  }

  findChildren = (inputs, currentTask, inputId) => {
    const filledChildren = []

    inputs.forEach(child => {
      const {
        parameters: { dependency: { input: childId } = {} },
      } = child

      if (inputId === childId && currentTask.evt_inputs) {
        const { result } =
          currentTask.evt_inputs.find(({ input }) => child.id === input) || {}

        const children = this.findChildren(inputs, currentTask, child.id)

        if (result) {
          filledChildren.push({
            result,
            children,
            ...child,
          })
        }
      }
    })

    return filledChildren
  }

  renderUnits() {
    const {
      activeJob: { allowed_locus_groups, allowed_locuses },
    } = this.props
    const resultArr = []

    if (this.checkData(allowed_locus_groups)) {
      resultArr.push(...allowed_locus_groups)
    }

    if (this.checkData(allowed_locuses)) {
      resultArr.push(...allowed_locuses)
    }

    return resultArr.map(({ id, name }) => (
      <span key={id} className="unit">
        {name}
      </span>
    ))
  }

  renderOutputs = () => {
    const {
      outputs,
      intl: { formatMessage },
      licensee: { usaDateFormat },
    } = this.props
    const dateFormat = getDateFormat(usaDateFormat)

    if (!outputs || !outputs.length) {
      return
    }

    return (
      <div className="job-outputs-list">
        {outputs.map(({ title, values, id, unit }) => {
          const { value, date_updated } = values[0] || {}
          const unitResult = unit || ''
          let result = 'N/A'

          if (value) {
            result = `${value} ${unitResult}`
          }

          return (
            <div className="output" key={id}>
              <div>
                {`${title}: `}
                <b>{parse(result)}</b>
              </div>
              {!!date_updated && (
                <div className="date-updated">
                  {/* eslint-disable-next-line max-len */}
                  {`${formatMessage(messages.lastUpdated)}: ${getFormattedDate(
                    date_updated,
                    dateFormat,
                  )}`}
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  handleChangeImageBlock = () => {
    this.setState(prevState => ({ showImageBlock: !prevState.showImageBlock }))
  }

  handleModalChange = () => {
    this.setState(prevState => ({ isModalOpen: !prevState.isModalOpen }))
  }

  handleShowVideo = () => {
    const { showVideoBlock } = this.state

    this.setState({
      showVideoBlock: !showVideoBlock,
      isVideoIframeLoading: false,
    })
  }

  handleChangeLoader = () => {
    this.setState({ isVideoIframeLoading: false })
  }

  findDependentLookupInputs = (inputs, inputId, typesToFind = []) => {
    const {
      currentTask: { evt_inputs },
    } = this.state

    return inputs.filter(
      ({ parameters: { lookup_table_source }, type: inputType }) =>
        typesToFind.some(type => type === inputType) &&
        lookup_table_source &&
        lookup_table_source?.parents?.length === 1 &&
        isParentLookupInputsFilledIn(
          lookup_table_source.parents,
          evt_inputs,
          inputId,
        ) &&
        lookup_table_source.fetch &&
        !lookup_table_source?.creates_lookup_object,
    )
  }

  findEvtInputMatch = (evtTask, inputId) =>
    evtTask.evt_inputs &&
    evtTask.evt_inputs.find(({ input }) => input === inputId)

  handleDependentLookupInputs = (
    inputs,
    evtTasks,
    inputId,
    matchCalculationFields,
  ) => {
    const {
      handleDependentLookupInputs,
      activeJobStatus,
      duplicatedGroupsIds,
      input_items,
    } = this.props

    const dependentLookupInputs = this.findDependentLookupInputs(
      inputs,
      inputId,
      [TYPE_INPUT_TEXT, TYPE_INPUT_NUMBER, TYPE_INPUT_DATE, TYPE_SELECT],
    )
    const data = []

    dependentLookupInputs.forEach((lookupInput, index) => {
      data[index] = {
        inputId: lookupInput.id,
        type: lookupInput.type,
        data: [],
        evt_inputs: [],
      }

      evtTasks.forEach(evtTask => {
        const evtInputMatch = this.findEvtInputMatch(evtTask, lookupInput.id)

        if (evtTask.id) {
          data[index].data.push({
            evt_task: evtTask.id,
          })
        }

        if (evtInputMatch) {
          data[index].evt_inputs.push(evtInputMatch.id)
        }
      })
    })

    const updatedGroup =
      input_items.find(
        item =>
          item.input_item_type === 'input_group' &&
          item.inputs.some(inputItem =>
            data.map(dataInput => dataInput.inputId).includes(inputItem.id),
          ),
      ) || {}

    if (
      data.length &&
      activeJobStatus !== STATUS_COMPLETED &&
      !duplicatedGroupsIds.includes(updatedGroup.id)
    ) {
      withPromise(handleDependentLookupInputs, {
        data,
        currentTaskID: this.props.id,
      })
    }

    if (matchCalculationFields && matchCalculationFields.length) {
      this.handleCalculationFields({ matchCalculationFields })
    }
  }

  isLookupParentFilled = lookup_table_source => {
    const {
      currentTask: { evt_inputs },
    } = this.state

    return !!(
      evt_inputs &&
      isParentLookupInputsFilledIn(lookup_table_source?.parents, evt_inputs)
    )
  }

  getIsDisabledLookupInput = lookup_table_source => {
    if (!lookup_table_source) {
      return false
    }

    return !!(
      lookup_table_source?.parents?.length &&
      (!(
        lookup_table_source?.editable ||
        lookup_table_source?.editable === undefined
      ) ||
        !this.isLookupParentFilled(lookup_table_source))
    )
  }

  getDependentLookupInputHint = lookup_table_source => {
    if (
      !this.isLookupParentFilled(lookup_table_source) &&
      lookup_table_source?.parents?.length
    ) {
      const {
        intl: { formatMessage },
      } = this.props
      const lastParentInputs =
        lookup_table_source?.parents?.map(
          ({ inputs }) => inputs[inputs.length - 1],
        ) || []
      const inputs =
        this.getAllInputs().filter(({ id: inputId }) =>
          lastParentInputs.includes(inputId),
        ) || []

      const title = inputs.map(({ title }) => title).join(', ')
      if (!title) {
        return null
      }

      return <Hint>{`${formatMessage(messages.setValueFor)} ${title}`}</Hint>
    }

    return null
  }

  renderInput = input => {
    const {
      currentTask,
      isDisabledInput,
      state,
      isFocusedInput,
      isDebouncing,
      errors,
    } = this.state
    const {
      input_items,
      resetInvalidDates,
      activeJob: { id: activeJobId },
    } = this.props
    const {
      id,
      parameters: {
        lookup_table_source,
        display,
        dependency: { input: inputID } = {},
      },
    } = input
    const dependency = { value: '', title: '' }
    const inputs = input_items.filter(
      ({ input_item_type }) => input_item_type === 'input',
    )
    const inputGroups = input_items.filter(
      ({ input_item_type }) => input_item_type === 'input_group',
    )
    let inputGroupsInputs = []

    if (inputGroups.length) {
      inputGroups.forEach(({ inputs }) => {
        inputGroupsInputs = [...inputGroupsInputs, ...inputs]
      })
    }

    const { title, type } =
      this.getAllInputs().find(({ id }) => id === inputID) || {}
    const fieldState = this.getFieldValidation() || isDisabledInput
    const isTaskCompleted = state === STATUS_COMPLETED

    if (inputID && title) {
      dependency.title = title
      dependency.type = type

      if (currentTask.evt_inputs) {
        const { result } =
          currentTask.evt_inputs.find(({ input }) => inputID === input) || {}

        if (result) {
          dependency.value = result
        }
      }
    }

    const filledChildren = this.findChildren(
      this.getAllInputs(),
      currentTask,
      input.id,
    )
    const isCheckbox = display === 'checkbox'
    const isInputDisabled =
      fieldState || this.getIsDisabledLookupInput(lookup_table_source)
    const inputHint = this.getDependentLookupInputHint(lookup_table_source)

    return (
      <JobField
        key={id}
        index={id}
        className={cn('job-field-main-box', { isCheckbox, isInputDisabled })}
        inputInfo={input}
        disabled={isInputDisabled}
        isFocusedInput={isFocusedInput}
        isTaskCompleted={isTaskCompleted}
        dependency={{
          dependency,
          children: filledChildren,
          currentEvtTask: currentTask,
          currentTaskID: this.props.id,
        }}
        inputData={this.findInputData(id)}
        onJobTaskAutoSave={this.onJobTaskAutoSave}
        onJobTaskValueRange={this.onJobTaskValueRange}
        onJobTaskFocusedInput={this.onJobTaskFocusedInput}
        handleDependentLookupInputs={this.handleDependentLookupInputs}
        resetInvalidDates={resetInvalidDates}
        activeJobId={activeJobId}
        clearCurrentTask={this.clearCurrentTask}
        inputs={[...inputGroupsInputs, ...inputs]}
        isDebouncing={isDebouncing}
        setIsDebouncing={this.setIsDebouncing}
        inputHint={inputHint}
        errors={errors}
      />
    )
  }

  renderInputGroup = (group, duplicateMatches, inputGroupIndex) => {
    const {
      duplicateInputGroup,
      deleteDuplicatedInputGroup,
      onJobTaskListRefresh,
      onJobListRefresh,
      featureFlags,
      input_items,
    } = this.props
    const {
      currentTask: { evt_inputs, id: evtTaskId },
    } = this.state
    const { inputs, id, availability, parameters } = group
    const isEvaluationAggregationParentTask = input_items.some(
      item =>
        item.input_item_type === 'input_group' &&
        (item?.parameters?._evaluation_aggregation_source ||
          item?.parameters?._evaluation_aggregation_scope ||
          item?.parameters?._evaluation_aggregation_route ||
          (Array.isArray(item?.preview_input_output) &&
            item.preview_input_output.length > 0)),
    )
    const hideEvaluationAggregationDuplicateControls = Boolean(
      isEvaluationAggregationParentTask &&
        (parameters?._evaluation_aggregation_source ||
          parameters?._evaluation_aggregation_route ||
          (Array.isArray(group.preview_input_output) &&
            group.preview_input_output.length > 0)),
    )

    if (
      canRenderConditionalInputOrGroup(
        evt_inputs,
        parameters,
        availability,
        evtTaskId,
        id,
        CONDITIONAL_ITEM_TYPE.INPUT_GROUPS,
      ) &&
      featureFlags.CONDITIONAL_INPUTS
    ) {
      return null
    }

    const isSomeInputsAvailable = inputs?.some(
      input =>
        !canRenderConditionalInputOrGroup(
          evt_inputs,
          input.parameters,
          input.availability,
          evtTaskId,
          input.id,
          CONDITIONAL_ITEM_TYPE.INPUTS,
        ),
    )

    return inputs.length && isSomeInputsAvailable ? (
      <InputGroupItem
        evtInputs={evt_inputs}
        key={id}
        group={group}
        duplicateMatches={duplicateMatches}
        inputGroupIndex={inputGroupIndex}
        duplicateInputGroup={duplicateInputGroup}
        deleteDuplicatedInputGroup={deleteDuplicatedInputGroup}
        onJobTaskListRefresh={onJobTaskListRefresh}
        onJobListRefresh={onJobListRefresh}
        renderInput={this.renderInput}
        forceShowDuplicateControls={hideEvaluationAggregationDuplicateControls}
      />
    ) : null
  }

  renderInputList = input_items =>
    input_items.map(item => {
      const { input_item_type, id, original_input_group_id } = item

      if (input_item_type === 'input') {
        return this.renderInput(item)
      }

      const duplicatedGroups = input_items.filter(
        group =>
          group.input_item_type === 'input_group' &&
          group.original_input_group_id,
      )
      const duplicateMatches = duplicatedGroups.filter(
        group =>
          id === group.original_input_group_id ||
          id === group.id ||
          original_input_group_id === group.original_input_group_id,
      )

      if (original_input_group_id) {
        this.inputGroupIndex += 1
      } else {
        this.inputGroupIndex = 1
      }

      return this.renderInputGroup(item, duplicateMatches, this.inputGroupIndex)
    })

  onTaskToggle = () => {
    if (this.taskRef) {
      this.taskRef.current.scrollIntoView()
    }
  }

  handleModalImageLoad = e => {
    const img = e.target
    const naturalW = img.naturalWidth
    const naturalH = img.naturalHeight

    // Calculate target dimensions based on viewport
    const targetW = window.innerWidth * 0.8
    const targetH = window.innerHeight * 0.8

    // Calculate scale factors for width and height
    const scaleW = targetW / naturalW
    const scaleH = targetH / naturalH

    // Use the smaller scale to ensure the image fits within the viewport
    let finalScale = Math.min(scaleW, scaleH)

    // For small images (less than 300px in either dimension), increase the scale
    // but don't make them larger than the target dimensions
    if (naturalW < 420 || naturalH < 420) {
      // Increase scale for small images, but don't make them larger than target dimensions
      finalScale = Math.min(
        Math.max(1.5, finalScale),
        Math.min(targetW / naturalW, targetH / naturalH),
      )

      if (targetW < 480) {
        finalScale = 1.2
      }
    }

    if (naturalH > 800) {
      let point = 0.8
      if (targetW <= 1200) {
        point = 0.7
      }
      if (targetW <= 480) {
        point = 1.2
      }
      finalScale = point
    }
    // Find the image-wrap-content container and set the scale
    const wrap = document.querySelector('.image-wrap-content')
    if (wrap) {
      wrap.style.setProperty('--img-modal-scale', finalScale)
    }
  }

  renderInstructionImage = image => {
    const {
      intl: { formatMessage },
    } = this.props
    const { showImageBlock, isModalOpen } = this.state
    const imageTitle = showImageBlock ? messages.hideImage : messages.showImage

    return (
      <div className={cn('wrap', { showBlock: showImageBlock })}>
        <ImageIcon />
        <div className="title" onClick={this.handleChangeImageBlock}>
          {formatMessage(imageTitle)}
        </div>
        <Collapse in={showImageBlock}>
          <img // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
            className="image"
            src={image}
            onClick={this.handleModalChange}
            alt=""
          />
          <ImageModal open={isModalOpen} onClose={this.handleModalChange}>
            <div className="modal-content">
              <div className="image-wrap-content">
                {/* Hidden image to calculate and apply scaling */}
                <img
                  src={image}
                  onLoad={this.handleModalImageLoad}
                  style={{ display: 'none' }}
                  alt=""
                />
                {/* Visible image with animation */}
                <ReactImageAppear
                  src={image}
                  animationDuration="2s"
                  placeholderStyle={{
                    backgroundColor: 'transparent',
                  }}
                  className="modal-image"
                />
              </div>
              <div className="btn-wrap">
                <IconButton onClick={this.handleModalChange}>
                  <CloseIcon />
                </IconButton>
              </div>
            </div>
          </ImageModal>
        </Collapse>
      </div>
    )
  }

  render() {
    const {
      id,
      index,
      title,
      input_items,
      activeTask,
      locusList,
      locusGroupList,
      instructions,
      needs_locus,
      needs_locus_group,
      needs_multi_unit,
      assigned_user_groups,
      assigned_users,
      original_task_id,
      duplicable,
      tasksData,
      optional,
      evt_tasks,
      state,
      handleCloseInfoModal,
      isInfoModalOpen,
      image,
      video,
      activeJobStatus,
      policy_indicators,
      resetInvalidDates,
      onJobTaskListRefresh,
      triggeredInstructions,
      activeJob: {
        created_by,
        created_by_trigger_rule,
        start_date_time,
        end_date_time,
        series,
        allowed_locus_groups,
        allowed_locuses,
        number,
      },
      intl: { formatMessage },
      licensee: { usaDateFormat, usaTimeFormat },
      isLoadJobInput,
      featureFlags,
      preview_inputs: previewList,
    } = this.props
    const {
      currentTask,
      isDialogOpen,
      popupTitle,
      popupMessage,
      popupAction,
      locusGroup,
      locus,
      isExtraMenuOpen,
      isOpenReassignDialog,
      anchor,
      activeUnits,
      activeUnitId,
      showVideoBlock,
      isVideoIframeLoading,
      isDisabledInput,
      reassignType,
      multiChoiceMode,
      savingEvtJobEntry,
      multiUnitTaskIds,
      isDebouncing,
      errors,
    } = this.state
    const { evt_inputs } = currentTask
    const { name } = created_by || created_by_trigger_rule || {}
    const isTasksDataExist = Object.keys(tasksData).length > 1
    const isTaskOpen =
      (isTasksDataExist &&
        tasksData[activeTask] === 'open' &&
        activeTask === id) ||
      activeTask === id
    const unavailableUnits = !needs_locus_group && !needs_locus
    const locusListData = this.getLocusListData()
    const checkInputs = this.checkData(input_items) && currentTask
    const fieldState = this.getFieldValidation() || isDisabledInput
    const isListExist = this.checkData(this.renderProperList())
    const extraMenuItems = (
      <div className="extra-actions">
        {this.getExtraMenuList(REASSIGN_ITEM)}
        {series && this.getExtraMenuList(REASSIGN_SERIES)}
        {duplicable && this.getExtraMenuList(DUPLICATE_ITEM)}
        {duplicable && this.getExtraMenuList(DUPLICATE_ITEM_WITH_DATA)}
        {original_task_id && this.getExtraMenuList(DELETE_ITEM)}
      </div>
    )
    const showIconPlace =
      this.checkData(allowed_locus_groups) || this.checkData(allowed_locuses)
    const timeDisplay = getTimeFormat(usaTimeFormat)
    const dateTimeDisplay = `${
      usaDateFormat ? 'MM-DD-YY' : 'DD-MM-YY'
    } ${timeDisplay}`
    const dateRange =
      start_date_time !== end_date_time
        ? `${getFormattedDate(
            start_date_time,
            dateTimeDisplay,
          )} - ${getFormattedDate(end_date_time, dateTimeDisplay)}`
        : getFormattedDate(start_date_time, dateTimeDisplay)
    const showData = dateRange || showIconPlace
    const isTaskCompleted = state === STATUS_COMPLETED
    const videoTitle = showVideoBlock ? messages.hideVideo : messages.showVideo
    const embededVideo = embedableYoutubeVideo(video)
    const isPresellEvaluationTask = input_items.some(
      item =>
        item.input_item_type === 'input_group' &&
        (item?.parameters?._evaluation_aggregation_source ||
          item?.parameters?._evaluation_aggregation_scope ||
          item?.parameters?._evaluation_aggregation_route ||
          (Array.isArray(item?.preview_input_output) &&
            item.preview_input_output.length > 0)),
    )
    const jobAndTaskStatus =
      activeJobStatus === STATUS_COMPLETED || isTaskCompleted
    const formatPreview = usaDateFormat ? 'MM-DD-YY' : 'DD-MM-YY'

    return (
      <>
        <Paper
          className={cn('job-item job-task', { 'task-opened': isTaskOpen })}
          ref={this.taskRef}>
          <div
            className="job-task-head"
            onClick={() => this.onJobTaskClickHandler(id)}>
            <div className="job-task-info">
              <span className="job-task-badges">
                {this.getStatusIcon()}
                <span className="task-index">{index}</span>
                {(duplicable || !!original_task_id) && (
                  <DuplicateIcon className="job-task-duplicate" />
                )}
              </span>
            </div>
            <div className="sf-job-settings">
              <IconButton
                size="small"
                className="actions-btn"
                onClick={this.onOpenExtraMenu}>
                <MoreVert />
              </IconButton>
            </div>
          </div>
          <div
            className="sf-job-title"
            onClick={() => this.onJobTaskClickHandler(id)}>
            {title}
            {!optional && <span className="job-task-required">*</span>}
          </div>
          <PreviewInputValues previewList={previewList} />
          {isListExist && (
            <ul className={cn('list', { 'full-list': isTaskOpen })}>
              {this.renderProperList()}
            </ul>
          )}
          <Collapse
            className="job-task-box"
            in={isTaskOpen}
            timeout={200}
            onEntered={this.onTaskToggle}
            onExited={() => {
              if (!activeTask) {
                this.onTaskToggle()
              }
            }}>
            <div className={cn({ 'job-task-completed': jobAndTaskStatus })}>
              {!!triggeredInstructions && (
                <div className="job-task-notification">
                  <span className="job-task-notification-icon">i</span>
                  {triggeredInstructions.map(
                    ({ evt_input_id, type, title, value }) => {
                      const isDate = type === TYPE_INPUT_DATE
                      const isDateTime = type === TYPE_INPUT_DATE_TIME
                      const isFile =
                        type === TYPE_INPUT_FILE && value.uri !== undefined
                      let formattedValue = value

                      if (isDate) {
                        formattedValue = getFormattedDate(
                          value,
                          formatPreview,
                        ).toString()
                      }

                      if (isDateTime) {
                        formattedValue = getFormattedDate(
                          value,
                          `${formatPreview} ${timeDisplay}`,
                        )
                          .toString()
                          .substring(0, 16)
                      }

                      if (isFile) {
                        formattedValue = ''
                      }

                      return (
                        <>
                          <div
                            key={evt_input_id}
                            className="job-task-notification-title">
                            {`${title}: ${formattedValue}`}
                          </div>
                          {isFile && this.renderInstructionImage(value.uri)}
                        </>
                      )
                    },
                  )}
                </div>
              )}
              {!isPresellEvaluationTask &&
                (instructions || image || embededVideo) && (
                  <div className="job-task-notification">
                    <span className="job-task-notification-icon">i</span>
                    {instructions && (
                      <div
                        className={cn('job-task-notification-title', {
                          noPreLine: featureFlags.INSTRUCTIONS_TEXT_EDITOR,
                        })}>
                        {featureFlags.INSTRUCTIONS_TEXT_EDITOR ? (
                          <TextEditor
                            input={{ value: instructions }}
                            showToolbar={false}
                            readOnly
                          />
                        ) : (
                          instructions
                        )}
                      </div>
                    )}
                    {image && this.renderInstructionImage(image)}
                    {embededVideo && (
                      <div
                        className={cn('wrap', { showBlock: showVideoBlock })}>
                        <VideoIcon />
                        <div className="title" onClick={this.handleShowVideo}>
                          {formatMessage(videoTitle)}
                        </div>
                        <Collapse in={showVideoBlock}>
                          <div className="iframe-wrapper">
                            {isVideoIframeLoading && <Loading pastDelay />}
                            <iframe
                              src={embededVideo}
                              frameBorder="0"
                              allow="autoplay; encrypted-media"
                              title="video"
                              allowFullScreen="1"
                              onLoad={this.handleChangeLoader}
                            />
                          </div>
                        </Collapse>
                      </div>
                    )}
                  </div>
                )}
            </div>
            {!needs_multi_unit && unavailableUnits && (
              <JobTaskUnits
                evt_tasks={evt_tasks}
                locus={locus}
                locusGroup={locusGroup}
                locusList={locusListData}
                locusGroupList={locusGroupList}
                needs_locus={needs_locus}
                needs_locus_group={needs_locus_group}
                input_items={input_items}
                getSuitableTask={this.getSuitableTask}
                setCurrentTaskUnits={this.setCurrentTaskUnits}
              />
            )}
            {!needs_multi_unit &&
              needs_locus_group &&
              locusGroupList.map(item => (
                <CollapsibleUnits
                  {...this.props}
                  key={item.id}
                  data={item}
                  type="locusGroup"
                  locus={locus}
                  locusGroup={locusGroup}
                  activeUnits={activeUnits}
                  activeUnitId={activeUnitId}
                  fieldState={fieldState}
                  availableInputs={checkInputs}
                  locusList={locusListData}
                  currentTask={currentTask}
                  isTaskCompleted={isTaskCompleted}
                  setCurrentTaskUnits={this.setCurrentTaskUnits}
                  findInputData={this.findInputData}
                  onJobTaskAutoSave={this.onJobTaskAutoSave}
                  onJobTaskValueRange={this.onJobTaskValueRange}
                  onJobTaskFocusedInput={this.onJobTaskFocusedInput}
                  clearCurrentTask={this.clearCurrentTask}
                  handleUnitsChange={this.handleUnitsChange}
                  getSuitableTask={this.getSuitableTask}
                  checkData={this.checkData}
                  findChildren={this.findChildren}
                  resetInvalidDates={resetInvalidDates}
                  handleDependentLookupInputs={this.handleDependentLookupInputs}
                  savingEvtJobEntry={savingEvtJobEntry || isLoadJobInput}
                  handleDuplicateInputGroup={this.handleDuplicateInputGroup}
                  evtInputs={evt_inputs}
                  onJobTaskListRefresh={onJobTaskListRefresh}
                  isDebouncing={isDebouncing}
                  setIsDebouncing={this.setIsDebouncing}
                  getIsDisabledLookupInput={this.getIsDisabledLookupInput}
                  getDependentLookupInputHint={this.getDependentLookupInputHint}
                />
              ))}
            {!needs_multi_unit &&
              !needs_locus_group &&
              needs_locus &&
              locusList.map(item => (
                <CollapsibleUnits
                  {...this.props}
                  key={item.id}
                  data={item}
                  type="locus"
                  activeUnits={activeUnits}
                  activeUnitId={activeUnitId}
                  fieldState={fieldState}
                  availableInputs={checkInputs}
                  currentTask={currentTask}
                  isTaskCompleted={isTaskCompleted}
                  setCurrentTaskUnits={this.setCurrentTaskUnits}
                  findInputData={this.findInputData}
                  onJobTaskAutoSave={this.onJobTaskAutoSave}
                  onJobTaskValueRange={this.onJobTaskValueRange}
                  onJobTaskFocusedInput={this.onJobTaskFocusedInput}
                  clearCurrentTask={this.clearCurrentTask}
                  handleUnitsChange={this.handleUnitsChange}
                  getSuitableTask={this.getSuitableTask}
                  checkData={this.checkData}
                  findChildren={this.findChildren}
                  resetInvalidDates={resetInvalidDates}
                  handleDependentLookupInputs={this.handleDependentLookupInputs}
                  savingEvtJobEntry={savingEvtJobEntry}
                  handleDuplicateInputGroup={this.handleDuplicateInputGroup}
                  evtInputs={evt_inputs}
                  onJobTaskListRefresh={onJobTaskListRefresh}
                  isDebouncing={isDebouncing}
                  setIsDebouncing={this.setIsDebouncing}
                  getIsDisabledLookupInput={this.getIsDisabledLookupInput}
                  getDependentLookupInputHint={this.getDependentLookupInputHint}
                  errors={errors}
                />
              ))}
            {needs_multi_unit && (
              <JobTaskBulkRun
                {...this.props}
                locus={locus}
                locusGroup={locusGroup}
                activeUnits={activeUnits}
                activeUnitId={activeUnitId}
                fieldState={fieldState}
                availableInputs={checkInputs}
                locusList={locusListData}
                currentTask={currentTask}
                input_items={input_items}
                multiChoiceMode={multiChoiceMode}
                setCurrentTaskUnits={this.setCurrentTaskUnits}
                setMultiTaskUnits={this.setMultiTaskUnits}
                setMultiChoiceMode={this.setMultiChoiceMode}
                setCurrentTask={this.setCurrentTask}
                findInputData={this.findInputData}
                onJobTaskAutoSave={this.onJobTaskAutoSave}
                onJobTaskValueRange={this.onJobTaskValueRange}
                onJobTaskFocusedInput={this.onJobTaskFocusedInput}
                clearCurrentTask={this.clearCurrentTask}
                handleUnitsChange={this.handleUnitsChange}
                checkData={this.checkData}
                evt_tasks={evt_tasks}
                findChildren={this.findChildren}
                resetInvalidDates={resetInvalidDates}
                savingEvtJobEntry={savingEvtJobEntry}
                multiUnitTaskIds={multiUnitTaskIds}
                handleDuplicateInputGroup={this.handleDuplicateInputGroup}
                handleDependentLookupInputs={this.handleDependentLookupInputs}
                evtInputs={evt_inputs}
                onJobTaskListRefresh={onJobTaskListRefresh}
              />
            )}
            {!needs_multi_unit && unavailableUnits && checkInputs && (
              <div className={cn({ 'job-task-completed': fieldState })}>
                <JobTaskPolicies
                  needsLocus={needs_locus}
                  needsLocusGroup={needs_locus_group}
                  policyIndicators={policy_indicators}
                />
                {this.renderOutputs()}
                {this.renderInputList(input_items)}
              </div>
            )}
            {this.getTaskButton()}
          </Collapse>
          <div
            className="task-dropdown-icon"
            onClick={() => this.onJobTaskClickHandler(id)}>
            <ExpandMore />
          </div>
        </Paper>
        <ConfirmDialog
          open={isDialogOpen}
          cancel={{
            color: 'default',
            variant: 'outlined',
            customText: formatMessage(messages.cancel),
          }}
          onClose={this.onCloseConfirmDialog}
          onConfirmAction={popupAction}
          className="confirm-action dialog-primary-custom"
          title={popupTitle}
          message={popupMessage}
        />
        {ifWindowWidthLessThan(LAPTOP_BREAKPOINT) ? (
          <SidePopover
            open={isExtraMenuOpen}
            close={this.onCloseDrawerExtra}
            className="extra-menu"
            position="bottom">
            {extraMenuItems}
          </SidePopover>
        ) : (
          <Menu
            keepMounted
            anchorEl={anchor}
            open={Boolean(anchor)}
            onClose={this.onCloseMenuExtra}>
            {extraMenuItems}
          </Menu>
        )}
        {isOpenReassignDialog && (
          <ReassignDialog
            taskInfo={{
              id,
              title,
              assigned_user_groups,
              assigned_users,
            }}
            open={isOpenReassignDialog}
            fullScreen={ifWindowWidthLessThan(TABLET_BREAKPOINT)}
            onClose={this.onCloseReassignDialog}
            reassignType={reassignType}
          />
        )}
        <SidePopover
          open={isInfoModalOpen}
          close={handleCloseInfoModal}
          className="extra-menu info-block"
          position="bottom"
          backDrop={{ invisible: true }}>
          <div className="info-wrapper">
            <div className="header">
              <span>{`# ${number}`}</span>
              <div>
                {formatMessage(messages.createdBy)}:{' '}
                <span className="created-by">{name}</span>
              </div>
            </div>
            <div className={cn('content', { 'show-data': showData })}>
              {dateRange && (
                <div
                  className={cn('date-range-wrap', {
                    'show-units': showIconPlace,
                  })}>
                  <div className="date">
                    <DateIcon />
                    <span>{dateRange}</span>
                  </div>
                  {series && (
                    <div className="series">
                      <RepeatIcon />
                      <span>
                        {formatMessage({ id: series.repeat_frequency })}
                      </span>
                    </div>
                  )}
                </div>
              )}
              <div className="units-wrap">
                {showIconPlace && <PlaceIcon />}
                {this.renderUnits()}
              </div>
            </div>
          </div>
        </SidePopover>
      </>
    )
  }
}

export default connect(
  state => ({
    isLoadEvtTask: state.getIn(['myJobs', 'isLoadEvtTask']),
    previewInputs: state.getIn(['myJobs', 'previewInputs']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
    isLoadJobInput: state.getIn(['myJobs', 'isLoadJobInput']),
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
    duplicatedGroupsIds: state.getIn(['myJobs', 'duplicatedGroupsIds']),
  }),
  {
    saveJobTaskInput,
    updateJobTaskInput,
    saveJobMultiTaskInputs,
    updateJobMultiTaskInputs,
    createEvtJobTask,
    createEvtJobMultiTask,
    updateJobTask,
    deleteTask,
    showNotice,
    resetInvalidDates,
    duplicateInputGroup,
    deleteDuplicatedInputGroup,
    evaluateCalculationFields,
    fetchJobTaskList,
    clearEvtInputsResults,
    handleDependentLookupInputs,
    setPreviewInputs,
    updateTaskPreviewInputs,
  },
)(injectIntl(JobTask))
